import Vue from 'vue';
import {supCharacter} from './supCharacter';

export function register() {
    Vue.filter('supCharacter', function (value) {
        return supCharacter(value);
    })
}



// WEBPACK FOOTER //
// ./src/filter/index.js